import { actionGenerator, IReduxAction } from '../../utils/actions';

export const UPDATE_RECOMMENDED_DEPOSIT_AMOUNT = 'BALANCE :: UPDATE_RECOMMENDED_DEPOSIT_AMOUNT';

export type TUpdateRecommendedDepositAmountAction = IReduxAction<typeof UPDATE_RECOMMENDED_DEPOSIT_AMOUNT, number>;

export const updateRecommendedDepositAmount = actionGenerator<typeof UPDATE_RECOMMENDED_DEPOSIT_AMOUNT, number>(
  UPDATE_RECOMMENDED_DEPOSIT_AMOUNT,
);
